module.exports = __webpack_public_path__ + "img/img-3.e2ec1544.png";